import { useEffect } from 'react';
import { usePostHog } from '@posthog/react';
import logEvent from 'analytics/ga';
import useRoutePathname from 'analytics/useRoutePathname';

const usePageViewAnalytics = () => {
    const locationInfo = useRoutePathname();
    const posthog = usePostHog();
    useEffect(() => {
        posthog?.capture('$pageview', {
            $current_url: `${window.location.origin}${locationInfo.route}`,
            route: locationInfo.route,
            pathname: locationInfo.pathname,
            params: locationInfo.params,
        });
        logEvent('page_view');
    }, [locationInfo, posthog]);
};

export default usePageViewAnalytics;
